import React from 'react';
import { Empty } from '@frontend/app/refresh-components';
import { BuildingColumnsIcon } from '@revfluence/fresh-icons/regular/esm';
import type { LocationEntry } from '@/types/demographics';
import { DataRankCard } from '../components/data-rank-card';

interface CityDistributionViewProps {
  topCitiesData?: LocationEntry[];
}

export const CityDistributionView: React.FC<CityDistributionViewProps> = ({ topCitiesData }) => {
  if (!topCitiesData || topCitiesData.length === 0) {
    return (
      <Empty
        icon={BuildingColumnsIcon}
        title="No Top Cities Data"
        description="Audience city breakdown is not available for this creator."
        size="lg"
      />
    );
  }

  return (
    <div className="space-y-2 w-full">
      {topCitiesData.map((cityEntry, index) => {
        if (!cityEntry.name || typeof cityEntry.percentage !== 'number') {
          return null;
        }
        return (
          <DataRankCard
            key={cityEntry.name}
            rank={index + 1}
            text={`${cityEntry.name} (${cityEntry.percentage.toFixed(1)}%)`}
            className="w-full"
          />
        );
      })}
      <DataRankCard
        rank={topCitiesData.length + 1}
        text="Other"
        className="w-full"
      />
    </div>
  );
};

CityDistributionView.displayName = 'CityDistributionView';
